import type { SimilarMap } from '../types.js';

/**
 * 同义词替换映射
 * 对称呼中的近义词进行替换
 */
export const similarMap: SimilarMap = {
  '晜': '兄',
  '哥': '兄',
  '姐': '姊',
  '侄': '姪',
  '婿': '壻',
  '嬷': '嫲',
  '祖父': '王父',
  '祖母': '王母',
  '孙女婿': '孙婿',
  '甥女婿': '甥婿',
  '侄女婿': '侄婿',
  '孙媳妇': '孙妇',
  '甥媳妇': '甥妇',
  '侄媳妇': '侄妇',
  '弟媳妇': '弟妇',
};

export default similarMap;
